import { Outlet } from 'react-router-dom';
import { SiteHeader } from './SiteHeader';
import { Sidebar } from './Sidebar';
import { PasskeyEnrollmentPrompt } from '@/components/features/auth/PasskeyEnrollmentPrompt';

export function AppLayout() {
  return (
    <div className="flex h-screen flex-col bg-slate-50 dark:bg-navy-950">
      <SiteHeader />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
      {/* Post-login nudge to set up a passkey (self-hides when not applicable). */}
      <PasskeyEnrollmentPrompt />
    </div>
  );
}
